import React from 'react';
import useLanguage from '../../hooks/useLanguage';
import companyData from '../../data/company.json';
import translationsData from '../../data/translations.json';
import Card from '../common/Card';
import * as FiIcons from 'react-icons/fi';

/**
 * CoreTechnologies Component
 * Displays company's core technologies in grid layout
 */
const CoreTechnologies = () => {
  const { language } = useLanguage();

  const technologiesTitle = language === 'ko'
    ? translationsData.titles.coreTechnologies
    : translationsData.titles.coreTechnologiesEn;

  // Dynamic icon rendering
  const getIcon = (iconName) => {
    const Icon = FiIcons[iconName];
    return Icon ? <Icon className="w-12 h-12 text-blue-600" /> : <FiIcons.FiCpu className="w-12 h-12 text-blue-600" />;
  };

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Title */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {technologiesTitle}
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
        </div>

        {/* Technologies Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {companyData.technologies.map((tech, index) => (
            <Card key={index} className="p-8 hover:shadow-xl transition-all duration-300">
              {/* Icon */}
              <div className="flex justify-center mb-4">
                <div className="p-4 bg-blue-50 rounded-full">
                  {getIcon(tech.icon)}
                </div>
              </div>

              {/* Technology Name */}
              <h3 className="text-xl font-semibold text-gray-900 mb-3 text-center">
                {language === 'ko' ? tech.name : tech.nameEn}
              </h3>

              {/* Description */}
              <p className="text-gray-600 leading-relaxed text-center">
                {language === 'ko' ? tech.description : tech.descriptionEn}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreTechnologies;
